// Libs
import * as R from 'ramda';

// Types
import { DIS } from '@typings/dis';

export const isRotaryClub = (clubType?: string): boolean =>
  R.equals(clubType, DIS.ClubTypeEnum.RotaryClub);
